import { rpc } from './rpc';
import {
  Evento,
  Motorista,
  Veiculo,
  Motivo,
  Cliente,
  TipoDeDespesa,
  Fop,
  Foa,
  Fornecedor,
  Despesa,
  Atendimento,
} from './schema';

export interface SyncParams {
  motoristas_mat?: null | string;
  veiculos_mat?: null | string;
  eventos_mat?: null | string;
  eventos?: Evento[];
  despesas?: Despesa[];
  atendimentos?: Atendimento[];
  fornecedores?: Fornecedor[];
  motivos_mat?: null | string;
  clientes_mat?: null | string;
  despesas_mat?: null | string;
  fops_mat?: null | string;
  foas_mat?: null | string;
  fornecedores_mat?: null | string;
  tipos_de_despesa_mat?: null | string;
  atendimentos_mat?: null | string;
}

export interface SyncData {
  motoristas?: Motorista[];
  veiculos?: Veiculo[];
  motivos?: Motivo[];
  clientes?: Cliente[];
  eventos?: Evento[];
  fops?: Fop[];
  foas?: Foa[];
  fornecedores?: Fornecedor[];
  
  tiposDeDespesa?: TipoDeDespesa[];
  tiposDeDespesasId?: number[];

  eventosAdded?: Evento[];
  fornecedoresAdded?: Fornecedor[];
  
  despesas?: Despesa[];
  despesasAdded?: Despesa[];

  atendimentosAdded?: Despesa[];
  atendimentos?: Atendimento[];
}

export const callSync = async (params: SyncParams) =>
  rpc<SyncParams, SyncData>('sync', params);
